<template>
  <div ref="editor"></div>
</template>

<script>
  export default {
    props: ['toolbarType', 'placeholder', 'value', 'required'],

    data() {
      return {
        _content: '',
      }
    },

    watch: {
      value(newVal, oldVal) {
        if (this.quill && newVal) {
          let updateHTML = newVal.replace(/(<code([^>]+)>)/ig, '')
          updateHTML = updateHTML.replace('</code>', '')

          if (updateHTML !== this._content) {
            this._content = updateHTML
            this.quill.pasteHTML(this._content)
          }
        } else if (this.quill) {
          this.quill.setText('')
        }

      },
    },

    methods: {
      initialize() {
        this.quill = new Kadenze.Quill(this.$refs.editor, this._props).init()

        if (this.value)
          this.quill.pasteHTML(this.value)

        this.quill.on('text-change', (delta, oldDelta, source) => {
          let html = this.$refs.editor.children[0].innerHTML

          const quill = this.quill
          const text = this.quill.getText()

          if (html === '<p><br></p>')
            html = ''

          this._content = html
          this.$emit('input', this._content)
          this.$emit('change', { html, text, quill })
        })

        this.quill.on('selection-change', range => {
          if (!range) {
            this.$emit('blur', this.quill)
          } else {
            this.$emit('focus', this.quill)
          }
        })
      },
    },

    mounted() {
      this.initialize()
    },

    beforeDestroy() {
      this.quill = null
      delete this.quill
    }
  }
</script>
